<template>
<div id="header" ref="cd" class="header">
  
  <HeaderContent class ="content" :title = "title" :info = "info" :additionalInfo = "additionalInfo"  /> 
</div>
</template>

<script>
export default {
  name: 'Header',
  props: ['title', 'info', 'additionalInfo', 'backgroundImage','mainPage'],
  data () {
    return {
      backgroundImg: 'something',
      
    }
  },
   methods:{
    
   }
}
</script>

<style scoped>
/*
.content{
  transform: translate(0%, 25vh);
}*/

/* Media Queries */
/* Tablet View */
@media (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
  .content{
    padding-left: 1.25rem;
   /* transform: translate(0%, 27vh); */
  }
}
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .content{
    padding-left: 2rem;
   /* transform: translate(0%, 25vh);*/
  }
}
/* Mobile View */
@media (min-width: 481px) and (max-width: 767px) and (orientation: portrait) {
  .header{
    /*min-height:100vh; */
  }
  .content{
   /*padding: 263px 0 157px 9px; */
   padding-left:9px;


   /* padding-left: 1.125rem;
    transform: translate(0%, 25vh);*/
  }
}


@media (min-width: 481px) and (max-width: 767px) and (orientation: landscape){
.content{
    padding-left: 1.125rem;
   /* transform: translate(0%, 25vh);*/
  }
}


@media (max-width: 480px){
  .header{
   /* min-height:100vh; */
  }
  .content{
    padding: 157px 0 157px 9px; 
  /* padding-left:9px;*/


   /* padding-left: 1.125rem;
    transform: translate(0%, 25vh);*/
  }
}
</style>
